import { isTauri } from '@tauri-apps/api/core';
import { createDesktopPlatform } from './desktop';
import type { Platform } from './types';
import { createWebPlatform } from './web';

/**
 * Picks the Platform implementation once, at startup (TechSpec §8.2). This is
 * the single place allowed to know which runtime the app is in; everything
 * else receives the result through PlatformProvider.
 */
export function resolvePlatform(detectTauri: () => boolean = isTauri): Platform {
  return detectTauri() ? createDesktopPlatform() : createWebPlatform();
}
